export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'waybillNo',
    align: 'center',
    fixed: 'left',
    width: 140,
    title: '运单编号',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'serviceByName',
    align: 'center',
    width: 110,
    title: '客服名字',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'waybillTransportMode',
    align: 'center',
    width: 130,
    title: '运输方式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleModel',
    align: 'center',
    width: 150,
    title: '车型',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleLength',
    align: 'center',
    width: 150,
    title: '车长（米）',
    sortable: true,
    sortType: 'number',
    slots: {
      default: 'vehicleLengthDefault',
    },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleQty',
    align: 'center',
    width: 150,
    title: '数量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'carrierName',
    align: 'center',
    width: 150,
    title: '承运商名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'vehicleNo',
    align: 'center',
    width: 150,
    title: '车牌号',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'driverName',
    align: 'center',
    width: 150,
    title: '司机姓名',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originProvinceName',
    align: 'center',
    width: 150,
    title: '始发地省份名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originCityName',
    align: 'center',
    width: 150,
    title: '始发地城市名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originDistrictName',
    align: 'center',
    width: 150,
    title: '始发地区县名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPlace',
    align: 'center',
    width: 150,
    title: '始发地园区',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originName',
    align: 'center',
    width: 180,
    title: '始发地发货方名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pickDateTime',
    align: 'center',
    width: 160,
    title: '实际提货时间',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationProvinceName',
    align: 'center',
    width: 150,
    title: '目的地省份名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationCityName',
    align: 'center',
    width: 150,
    title: '目的地城市名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationDistrictName',
    align: 'center',
    width: 150,
    title: '目的地区县名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationPlace',
    align: 'center',
    width: 150,
    title: '目的地园区',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'destinationName',
    align: 'center',
    width: 180,
    title: '目的地收货方名称',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'receiveDateTime',
    align: 'center',
    width: 160,
    title: '实际到货时间',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsName',
    align: 'center',
    width: 150,
    title: '货物名称合集',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsQty',
    align: 'center',
    width: 150,
    title: '总件数',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsWeight',
    align: 'center',
    width: 150,
    title: '预计总重量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsVolume',
    align: 'center',
    width: 150,
    title: '预计总体积',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'goodsValue',
    align: 'center',
    width: 150,
    title: '总货值',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'factWeight',
    align: 'center',
    width: 150,
    title: '实际总重量',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'factVolume',
    align: 'center',
    width: 150,
    title: '实际总体积',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payAmount',
    align: 'center',
    width: 150,
    title: '应付运费合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payCostAmount',
    align: 'center',
    width: 150,
    title: '应付费用合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'payTotalAmount',
    align: 'center',
    width: 150,
    title: '应付合计',
    sortType: 'number',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    align: 'center',
    width: 160,
    title: '运单创建时间',
    sortType: 'string',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
